"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./FullPageSpinner.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var spinnerClasses = (0, _cssClassesHelper.getBEMClasses)('full-page-spinner');
var FullPageSpinner = function FullPageSpinner(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  if (props.error) {
    console.error(props.error);
  }
  if (props.pastDelay) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.isVisible && /*#__PURE__*/_react["default"].createElement("div", {
      className: spinnerClasses('overlay')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: spinnerClasses('container')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: spinnerClasses('spinner')
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: spinnerClasses('text')
    }, t("Loading ...")))));
  } else {
    return null;
  }
};
FullPageSpinner.propTypes = {
  isVisible: _propTypes["default"].bool.isRequired
};
FullPageSpinner.defaultProps = {
  isVisible: true
};
var _default = exports["default"] = FullPageSpinner;